import { validatePresenceOf } from '@/shared/utils';

export const validate = company => {
  return validatePresenceOf(company, ['name', 'address', 'zipCode', 'city']);
};
